import React from 'react';
import PortfolioPage from './PortfolioPage';

function App() {
  return <PortfolioPage />;
}

export default App;
